import { useCallback, useMemo, useState } from "react";

import { useBlizzardEvents } from "../../analytics/hooks";
import { type ModalProps, type ShowModal } from "../../shared/hooks";

export const useLensSubmissionErrorsModalState = (visibleByDefault = false): [ModalProps, ShowModal] => {
    const [visible, setVisible] = useState(visibleByDefault);
    const { sendBlizzardEvent: sendBlizzardEventHandler } = useBlizzardEvents();

    const showModal = useCallback(() => {
        sendBlizzardEventHandler({
            event: "MYLENSES_MANAGEMENT_PAGE_ACTION",
            pageType: "LENS_DETAILS",
            action: "REJECTION_REASONS_OPEN",
        });
        setVisible(true);
    }, [setVisible, sendBlizzardEventHandler]);

    const onCancel = useCallback(() => {
        sendBlizzardEventHandler({
            event: "MYLENSES_MANAGEMENT_PAGE_ACTION",
            pageType: "LENS_DETAILS",
            action: "REJECTION_REASONS_CLOSE",
        });
        setVisible(false);
    }, [setVisible, sendBlizzardEventHandler]);

    return useMemo(
        () => [
            {
                visible,
                onCancel,
            },
            showModal,
        ],
        [visible, onCancel, showModal],
    );
};
